import { render, staticRenderFns } from "./addMaterial.vue?vue&type=template&id=388f0660&scoped=true"
import script from "./addMaterial.vue?vue&type=script&lang=js"
export * from "./addMaterial.vue?vue&type=script&lang=js"
import style0 from "./addMaterial.vue?vue&type=style&index=0&id=388f0660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388f0660",
  null
  
)

export default component.exports